import React, { useCallback, useMemo, useEffect } from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LineBalanceScaleIcon from 'LuxKit/Icons/line/LineBalanceScaleIcon'
import LineWalletIcon from 'LuxKit/Icons/line/LineWalletIcon'
import TileCard from 'tripPlanner/components/EntryPoints/Common/Tile/TileCard'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TileCardsGroup from './Common/Tile/TileCardsGroup'
import { arrayToMap } from 'lib/array/arrayUtils'
import * as Analytics from 'analytics/analytics'

export const TRIP_BUDGETS = [
  {
    activityBudget: 'A Little Splash',
    title: 'A Little Splash',
    description: 'Save where I can, spend where it counts.',
    icon: <LineUsdCircleIcon />,
  },
  {
    activityBudget: 'Mix & Match',
    title: 'Mix & Match',
    description: 'Some paid fun, every other day is fine.',
    icon: <LineBalanceScaleIcon />,
  },
  {
    activityBudget: 'Open Wallet',
    title: 'Open Wallet',
    description: 'If it sounds amazing, I’m in.',
    icon: <LineWalletIcon />,
  },
]

interface Props {
  activityBudget: Array<{
    activityBudget: string
    selected: boolean
  }>
  onBudgetSelect: (budget: string) => void
  onNext: () => void
  isGeneratingTrip: boolean
  stepNumber: number
  totalSteps: number
}

function AITripBudgetSelection({
  activityBudget,
  onBudgetSelect,
  onNext,
  isGeneratingTrip,
  stepNumber,
  totalSteps,
}: Props) {
  const handleOnClick = useCallback((budget: string) => {
    onBudgetSelect(budget)
    onNext()
  }, [onBudgetSelect, onNext])

  const tripBudgetMap = useMemo(() =>
    arrayToMap(activityBudget, budget => budget.activityBudget, budget => budget.selected),
  [activityBudget])

  useEffect(() => {
    Analytics.trackClientEvent({
      subject: 'activity_budget',
      action: 'view',
      category: 'trip_planner',
      type: 'nonInteraction',
    })
  }, [])

  return (
    <Group direction="vertical" gap={20} desktopGap={24}>
      <VerticalSpacer gap={8}>
        <BodyText variant="large" weight="bold">{stepNumber} of {totalSteps}</BodyText>
        <Heading variant="heading1">
          Activity <i>Budget</i>
        </Heading>
        <BodyText variant="large">
          What’s your activity budget looking like? (Don’t worry — we'll get to food shortly)
        </BodyText>
      </VerticalSpacer>
      <TileCardsGroup>
        {TRIP_BUDGETS.map((budget) => (
          <TileCard
            key={budget.activityBudget}
            title={budget.title}
            subtitle={budget.description}
            icon={budget.icon}
            value={budget.activityBudget}
            onClick={handleOnClick}
            selected={!!tripBudgetMap.get(budget.activityBudget)}
            disabled={isGeneratingTrip}
          />
        ))}
      </TileCardsGroup>
    </Group>
  )
}

export default AITripBudgetSelection
